module.exports = __webpack_public_path__ + "img/logo81-min.9f38241b.png";